import React from 'react';

function Blogcard({ id, image, category, title, author, date }) {
    const goSingle = () => {
        window.location.href = `/blogs/${id}`;
    };

    return (
        <div onClick={goSingle} className='rounded-[8px] flex flex-col space-y-3 cursor-pointer'>
            <div className='flex flex-col space-y-1 lg:w-[350px]'>
                <div className='h-[302px]'><img className='rounded-[8px] h-[280px] w-full' src={image} alt={title} /></div>
                <div className='text-[#008B39] text-start text-[16px] font-[400]'>{category}</div>
            </div>
            <div className='text-[#121927] text-[20px] lg:text-[24px] font-[500] text-start lg:w-[350px]'>{title}</div>
            <div className='flex flex-row justify-between items-center'>
                <span className='text-[16px] text-[#333333] font-[400]'>By {author}</span>
                <span className='text-[16px] text-[#828282] font-[400]'>{date}</span>
            </div>
        </div>
    );
}

export default Blogcard;
